<table-container noResultMessage="{{ 'No users available for this domain' | translate }}"
            [collection]="updatedUsers"
            (onPageChange)="onPageChange($event)"
            (onPerPageChange)="onPageSizeChange($event)"
            [progress]="progress">
    <table class="table table-hover" monSelectAllCheckbox>
        <thead>
            <tr>
                <th class="col-10" translate>User</th>
                <th class="col-10 text-right">
                    <span id="user-form-visible-checkbox" translate>Visible</span>
                    <input class="ml-1 vertical-align-middle"
                        aria-labelledby="user-form-visible-checkbox"
                        type="checkbox">
                </th>
                <th class="col-10 text-right">
                    <span id="user-form-send-report-checkbox" translate>Send report</span>
                    <input class="ml-1 vertical-align-middle"
                        aria-labelledby="user-form-send-report-checkbox"
                        type="checkbox">
                </th>
                <th class="col-10 text-right" translate>Admin</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let user of updatedUsers; let $index = index; trackBy: trackByUserId">
                <td>{{ user.name }}</td>
                <td class="text-right">
                           <span id="user-form-visible-item-checkbox" class="tw-sr-only" translate>Visible</span>
                           <input type="checkbox"
                           aria-labelledby="user-form-visible-item-checkbox"
                           [checked]="user.isVisible"
                           (click)="toggleVisible(user, $index)"
                           (keydown)="$event.key === 'Enter' || $event.key === ' ' ? toggleVisible(user, $index) : null"
                           [disabled]="user.customer_admin"/>
                </td>
                <td class="text-right">
                           <span id="user-form-send-report-item-checkbox" class="tw-sr-only" translate>Send report</span>
                           <input type="checkbox"
                           aria-labelledby="user-form-send-report-item-checkbox"
                           [checked]="user.hasSendReport"
                           (click)="toggleSendReport(user, $index)"
                           (keydown)="$event.key === 'Enter' || $event.key === ' ' ? toggleSendReport(user, $index) : null"
                           [disabled]="!user.isVisible">
                </td>
                <td class="text-right">
                    <span class="fas fa-check text-success" *ngIf="user.customer_admin"></span>
                    <span class="fas fa-ban text-danger" *ngIf="!user.customer_admin"></span>
                </td>
            </tr>
        </tbody>
    </table>
</table-container>
